import { render, staticRenderFns } from "./ViewDocument.vue?vue&type=template&id=d30760a6&scoped=true"
import script from "./ViewDocument.vue?vue&type=script&lang=js"
export * from "./ViewDocument.vue?vue&type=script&lang=js"
import style0 from "./ViewDocument.vue?vue&type=style&index=0&id=d30760a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30760a6",
  null
  
)

/* custom blocks */
import block0 from "./ViewDocument.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports